<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/euXGjl/tc-custom/9781452129808.jpg?1728259590313" alt="This image is the cover for the book Pork Chop"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Pork Chop
      </h1>
      <p class="bookDescription body article font2">
        <b>“Deals with one often-overlooked main ingredient . . . this versatile and delicious cut of pig is something we’re more than willing to read a whole book on.” —Food Republic</b><br/><br/> Pork chops are in! And no one knows more about them than Hall of Fame pitmaster Ray Lampe. They are lean, easy to cook, and the perfect protein choice for everyday meals. These sixty mouthwatering recipes celebrate this beloved cut in all its glory, capturing the splendor and range of chops with all their porky goodness in new and inspiring dishes, from Balsamic and Vanilla-Glazed Pork Chops to Spicy Pork Chop Lettuce Wraps. With as many recipe choices as there are cooking styles—batter and fry, marinate and grill, simmer and braise—this cookbook is a vital addition to any kitchen where meat’s what’s for dinner.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ray Lampe, Jody Horton
      </h2>
      
      <p class="authorDescription body article">Ray "Dr. BBQ" Lampe has been barbecuing professionally for over 20 years. He is the author of several cookbooks, including Ribs, Chops, Steaks, and Wings and Slow Fire. He lives in Florida.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Chronicle Books LLC
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?635743a8